import React from 'react';
import { Container, Card, Button} from 'react-bootstrap';
import { Typography, Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';

const courses = [
  {
    level: 'A1',
    description: 'German language A1 class, duration 2 months.',
    duration: '2 months',
    fee: '11,000 INR',
    imgSrc: 'https://img.freepik.com/free-vector/steps-concept-illustration_114360-7809.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid',
  },
  {
    level: 'A2',
    description: 'German language A2 class, duration 2 months.',
    duration: '2 months',
    fee: '13,000 INR',
    imgSrc: 'https://img.freepik.com/free-vector/business-merger-concept-illustration_114360-8642.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid',
  },
  {
    level: 'B1',
    description: 'German language B1 class, duration 2 months.',
    duration: '2 months',
    fee: '17,000 INR',
    imgSrc: 'https://img.freepik.com/free-vector/business-support-concept-illustration_114360-9863.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid',
  },
  {
    level: 'B2',
    description: 'German language B2 class, duration 2 months.',
    duration: '2 months',
    fee: '19,000 INR',
    imgSrc: 'https://img.freepik.com/free-photo/business-people-working-together_155003-14913.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid',
  },
];

const Courses = () => {


  const handleContactNow = (program) => {
    // Logic to send course details via WhatsApp
    const message = `I'm interested in the ${program.level} course. Please give me more details.`;
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = '+919495123689';
    ; // Replace with your WhatsApp number
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Container fluid id='Courses' className="p-4">
      <Helmet>
        <title>German Language Courses</title>
        <meta name="description" content="Explore our German language courses at Holy Institute. We offer A1, A2, B1, and B2 courses to help you achieve fluency." />
        <meta name="keywords" content="German language courses, A1 German, A2 German, B1 German, B2 German" />
      </Helmet>
      <Box mb={4}>
        <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'rgb(12, 12, 95)',fontFamily: 'Roboto Slab, serif' }} >
          Our German Language Courses
        </Typography>
        <Typography variant="body1" align="center"style={{fontFamily: 'Roboto Slab, serif'}}  paragraph>
          Holy Institute offers a range of German language courses designed to meet your needs, whether you're just starting or looking to refine your skills. Explore our offerings below and find the course that's right for you.
        </Typography>
        <Grid container spacing={4}>
          {courses.map((course, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card className='cardhover'>
                <Card.Img variant="top" src={course.imgSrc} />
                <Card.Body>
                  <Card.Title>{course.level} Course</Card.Title>
                  <Card.Text>{course.description}</Card.Text>
                  <Typography variant="body2" color="textSecondary">
                    Duration: {course.duration}
                  </Typography>
                  <Typography variant="h6" color="rgb(12, 12, 95)" sx={{ mt: 1,fontFamily: 'Roboto Slab, serif' }}>
                    Fee: {course.fee}
                  </Typography>
                 
                  <Button 
                    variant="contained" 
                    color="white" 
                    className="mt-2  text-white bgblue"
                    onClick={() => handleContactNow(course)}
                  >
                    Contact Now
                  </Button>
                </Card.Body>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      
    </Container>
  );
};

export default Courses;
